module.exports = __webpack_public_path__ + "img/file_present.e0795654.svg";